<template>
  <el-dialog title="批量修改运费" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <p>已选{{logisticsnum.total}}款商品，其中{{logisticsnum.count}}款需物流的商品支持批量修改运费</p>
      <p>快递运费统一设置为:</p>
      <el-form ref="form" :model="formdata" label-width="50px">
        <el-form-item>
          <el-radio-group v-model="formdata.shipping_set">
            <el-radio :label="item.value" v-for="(item,index) in shippingset" :key="index">
              <div class="radio_item" v-if="item.value===0">
                {{item.label}}
                <el-input type="text" v-model="formdata.shipping_fee" class="w160"></el-input>
                <span>元(默认0元，即商品免运费)</span>
              </div>
              <div class="radio_item" v-if="item.value===1">
                {{item.label}}
                <el-select v-model="formdata.fre_id" class="w160" placeholder="请选择">
                  <el-option
                    v-for="item in freoptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <p>仅选择“按件计费”的运费模版；仅在商品编辑中可选择”按重量计费“的运费模版。</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { shippingset } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "chooseClassifyDialog",
  props: ["visible", "ids", "logisticsnum"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      formdata: {
        shipping_set: 0,
        shipping_fee: 0,
        fre_id: ""
      },
      shippingset: shippingset,
      freoptions: []
    };
  },
  created() {
    this.queryfreight();
  },
  methods: {
    // 查询运费模板
    queryfreight() {
      let params = {};
      this.axios
        .post(api.goods_freight, params)
        .then(response => {
          if (response.data.code == 0) {
            this.freoptions = response.data.list || [];
          } else {
          }
        })
        .catch(() => {});
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 提交保存 批量添加到分类
    submitsave() {
      let params = {
        id: this.ids,
        shipping_set: this.formdata.shipping_set,
        shipping_fee: this.formdata.shipping_fee,
        fre_id: this.formdata.fre_id
      };
      this.axios
        .post(api.goods_edit_shipping, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$emit("success");
            this.$message({
              message: "批量修改运费成功",
            });
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

